import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class WhatsappSessionService {
  constructor(private httpClient: HttpClient,
              private router: Router,){}

  getNewSessionWhatsapp(uuid: string) {
    return this.httpClient.post(`${ environment.serverUrl }/checkSessionWhatsapp`, {uuid});
  }

  verifySessionWhatsapp(hash: string, deviceData: Record<string, unknown> = {}) {
    return this.httpClient.post(`${ environment.serverUrl }/app/whatsapp/verifySessionWhatsapp`, {
      hash,
      ...deviceData,
    });
  }

  getPapWhatsapp(hash: string) {
    return this.httpClient.post(`${ environment.serverUrl }/app/whatsapp/getPapWhatsapp`, { hash });
  }
}
